import { default as UserManagementPage } from ".";
import UserManagementService from "../../../infrastructure/api/userManagement.js";
import {
  loaderById,
  loaderCustomUrlById,
  loaderGrid,
  loaderReport,
} from "../../middleware/route-provider.js";
import LicensePage from "./license/index.js";
import YeksaUserManagementPage from "./main.js";
import UserLoginReportPage from "./reports/user-login-report.js";
import UserVerificationCodesReportPage from "./reports/user-verification-codes-report.js";
import RoleInfoModifyPage from "./role-info/RoleInfoModify.js";
import RoleInfoPage from "./role-info/index.js";
import TicketModifyPage from "./ticket/TicketModify.js";
import TicketViewPage from "./ticket/TicketView.js";
import TicketPage from "./ticket/index.js";
import UpdateHistoryModifyPage from "./update-history/UpdateHistoryModify.js";
import UpdateHistoryPage from "./update-history/index.js";
import UserInfoModifyPage from "./user-info/UserInfoModify.js";
import { normalizeUserKindForForm } from "../../../infrastructure/utils/userKindUtils";
import UserInfoPage from "./user-info/index.js";
import DeleteAllUserDataPage from "./delete-all-user-data/DeleteAllUserData.js";
import CategoryModifyPage from "./category/CategoryModify.js";
import CategoryPage from "./category/index.js";
export default {
  path: "UM",
  children: [
    {
      path: "",
      element: <UserManagementPage />,
    },
    {
      path: "Yeksa",
      element: <YeksaUserManagementPage />,
    },
    {
      path: "Yeksa/License",
      element: <LicensePage />,
      loader: async () => {
        try {
          const res = await UserManagementService.getRoleInfoListApi();
          if (res.status === 404) {
            throw new Response("Not Found", { status: 404 });
          }

          return res.data;
        } catch (error) {
          return null;
        }
      },
    },
    {
      path: "Yeksa/RoleInfo",
      element: <RoleInfoPage />,
      loader: async () => {
        try {
          const res = await UserManagementService.getRoleInfoListApi();
          if (res.status === 404) {
            throw new Response("Not Found", { status: 404 });
          }

          return res.data;
        } catch (error) {
          return null;
        }
      },
    },
    {
      path: "Yeksa/RoleInfo/:id",
      element: <RoleInfoModifyPage />,
      loader: async ({ params }) => {
        let id = params.id,
          result = {};

        if (params.id && params.id === "create") {
          id = null;
          result = {
            role: {
              isActive: false,
              roleDescription: "",
              roleName: "",
            },
          };
        }

        const res = await UserManagementService.getRoleInfoByIdApi(id);

        if (res.status === 404) {
          throw new Response("Not Found", { status: 404 });
        }
        // console.log({ ...res.data, ...result });
        return { ...res.data, ...result };
      },
    },
    {
      path: "Yeksa/userinfo",
      element: <UserInfoPage />,
      loader: async () => {
        try {
          const res = await UserManagementService.getUserInfoListApi();
          if (res.status === 404) {
            throw new Response("Not Found", { status: 404 });
          }

          return res.data || [];
        } catch (error) {
          return null;
        }
      },
    },
    {
      path: "Yeksa/userinfo/:id",
      element: <UserInfoModifyPage />,
      loader: async ({ params }) => {
        let id = params.id,
          result = {};

        if (params.id && params.id === "create") {
          id = 0;
          result = {
            userInfo: {
              email: "",
              firstName: "",
              isActive: true,
              lastName: "",
              mobile: "",
              roleId: "",
              roleName: "",
              userName: "",
              password: "",
              confirmPassword: "",
            },
          };
        }

        const res = await UserManagementService.getUserInfoByIdApi(id);

        if (res.status === 404) {
          throw new Response("Not Found", { status: 404 });
        }
        const payload = { ...res.data, ...result };
        if (payload?.userInfo) {
          payload.userInfo = {
            ...payload.userInfo,
            userKind: normalizeUserKindForForm(payload.userInfo.userKind),
          };
        }
        return payload;
      },
    },
    {
      path: "Yeksa/deleteAllUserData",
      element: <DeleteAllUserDataPage />,
    },
    {
      path: "Yeksa/UserLoginReport",
      element: <UserLoginReportPage />,
      loader: async () =>
        await loaderReport({
          url: "UM/Yeksa/UserLoginReport",
        }),
    },
    {
      path: "Yeksa/UserVerificationCodesReport",
      element: <UserVerificationCodesReportPage />,
      loader: async () =>
        await loaderReport({
          url: "UM/Yeksa/UserVerificationCodesReport",
        }),
    },

    {
      path: "Yeksa/UpdateHistory",
      element: <UpdateHistoryPage />,
      loader: async () =>
        await loaderGrid({
          url: "UM/UpdateHistory",
        }),
    },
    {
      path: "Yeksa/UpdateHistory/:id",
      element: <UpdateHistoryModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            updateHistory: {
              title: "",
              description: "",
              isActive: true,
              kind: "AppSourceChange",
            },
          },
          url: "UM/UpdateHistory",
        });
      },
    },

    {
      path: "Yeksa/Ticket",
      element: <TicketPage />,
      loader: async () =>
        await loaderGrid({
          url: "UM/Ticket",
        }),
    },
    {
      path: "Yeksa/Ticket/:id",
      element: <TicketModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            ticket: {
              categoryId: 0,
              userId: 0,
              userFullName: "",
              title: "",
              content: "",
              ticketStatus: "Pending",
              ticketPriority: "Low",
              url: "",
              isActiveTitle: "",
              isActive: true,
              categoryTitle: "",
              attachmentUrls: "",
            },
          },
          url: "UM/Ticket",
        });
      },
    },
    {
      path: "Yeksa/Ticket/View/:id",
      element: <TicketViewPage />,
      loader: async ({ params }) => {
        return await loaderCustomUrlById({
          params,
          initValue: {
            ticket: {
              userId: "0",
              userFullName: "",
              title: "",
              ticket: "",
              ticketStatus: "Pending",
              url: "",
              isActiveTitle: "",
              isActive: true,
              description: "",
              categoryTitle: "",
            },
          },
          url: "UM/Ticket/GetViewById",
        });
      },
    },

    {
      path: "Yeksa/Category",
      element: <CategoryPage />,
      loader: async () =>
        await loaderGrid({
          url: "UM/Category",
        }),
    },
    {
      path: "Yeksa/Category/:id",
      element: <CategoryModifyPage />,
      loader: async ({ params }) => {
        return await loaderById({
          params,
          initValue: {
            category: {
              id: 0,
              title: "",
              description: "",
              isActive: true,
            },
          },
          url: "UM/Category",
        });
      },
    },
  ],
};
